// Generated from Blacksky Branding/Badges/Light Purple/SVG — do not hand-edit shapes.
import Svg, {
  Defs,
  G,
  LinearGradient,
  Mask,
  Path,
  Rect,
  Stop,
} from 'react-native-svg'

export type BadgeCardProps = {width: number}

export function PeerModeratorCard({width}: BadgeCardProps) {
  return (
    <Svg width={width} height={width} viewBox="0 0 360 360" fill="none">
      <Rect width="360" height="360" rx="32" fill="#DCDCFF" />
      <Rect
        x="3"
        y="3"
        width="354"
        height="354"
        rx="29"
        stroke="url(#paint0_linear_2269_939)"
        strokeOpacity="0.6"
        strokeWidth="6"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M250.359 119.58C289.019 119.341 320.196 145.114 319.998 177.146C319.8 209.178 288.301 235.34 249.641 235.579C245.795 235.603 242.023 235.362 238.348 234.89C239.165 239.643 239.587 244.578 239.555 249.642C239.505 257.811 238.292 265.659 236.116 272.961L235.668 274.413L235.264 275.65C226.555 301.497 205.547 319.848 181.123 319.999C156.31 320.153 135.258 301.477 127.138 275.083C124.775 267.403 123.5 259.072 123.554 250.358C123.587 245.062 124.107 239.899 125.062 234.934C120.097 235.888 114.936 236.412 109.641 236.445C70.982 236.683 39.8039 210.91 40.0019 178.878C40.2 146.846 71.6999 120.685 110.359 120.446C115.421 120.414 120.354 120.831 125.105 121.647C124.634 117.974 124.398 114.204 124.422 110.36C124.661 71.701 150.821 40.1999 182.853 40.0009C214.885 39.8028 240.661 70.982 240.421 109.642C240.399 113.269 240.144 116.833 239.682 120.314C243.164 119.851 246.731 119.602 250.359 119.58ZM231.43 169.005C208.87 169.145 190.693 150.968 190.832 128.407L191.111 82.8566L170.614 82.9831L170.331 128.534C170.191 151.094 151.787 169.498 129.227 169.638L85.1396 169.908L85.0219 188.946L129.111 188.674C151.67 188.535 169.847 206.709 169.709 229.269L169.428 274.821L189.927 274.693L190.209 229.144C190.349 206.584 208.752 188.183 231.313 188.043L276.867 187.76L276.983 168.724L231.43 169.005Z"
        fill="black"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_2269_939"
          x1="346.377"
          y1="25.4615"
          x2="0.00221924"
          y2="293.389"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#F4F4FF" />
          <Stop offset="1" stopColor="#6D6DF6" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export function CommunityBuilderCard({width}: BadgeCardProps) {
  return (
    <Svg width={width} height={width} viewBox="0 0 360 360" fill="none">
      <Rect width="360" height="360" rx="32" fill="#DCDCFF" />
      <Rect
        x="3"
        y="3"
        width="354"
        height="354"
        rx="29"
        stroke="url(#paint0_linear_2269_1003)"
        strokeOpacity="0.6"
        strokeWidth="6"
      />
      <Rect x="50" y="244.998" width="64.9998" height="64.9986" fill="black" />
      <Rect
        x="115.008"
        y="180.002"
        width="64.9998"
        height="129.997"
        fill="black"
      />
      <Rect
        x="180.002"
        y="115.002"
        width="64.9998"
        height="194.996"
        fill="black"
      />
      <Rect x="245" y="50.002" width="64.9998" height="259.994" fill="black" />
      <Defs>
        <LinearGradient
          id="paint0_linear_2269_1003"
          x1="346.377"
          y1="25.4615"
          x2="0.00221924"
          y2="293.389"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#F4F4FF" />
          <Stop offset="1" stopColor="#6D6DF6" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export function FinancialSupporter1Card({width}: BadgeCardProps) {
  return (
    <Svg width={width} height={width} viewBox="0 0 360 360" fill="none">
      <Rect width="360" height="360" rx="32" fill="#DCDCFF" />
      <Rect
        x="3"
        y="3"
        width="354"
        height="354"
        rx="29"
        stroke="url(#paint0_linear_2269_789)"
        strokeOpacity="0.6"
        strokeWidth="6"
      />
      <Path
        d="M184.87 301.734L175.131 301.734L175.131 58.2617L184.87 58.2617L184.87 301.734Z"
        fill="black"
        stroke="black"
        strokeWidth="9.23677"
      />
      <Path
        d="M301.738 175.129L301.738 184.868L58.2607 184.868L58.2607 175.129L301.738 175.129Z"
        fill="black"
        stroke="black"
        strokeWidth="9.23677"
      />
      <ellipse
        cx="276.173"
        cy="179.999"
        rx="43.8255"
        ry="43.826"
        transform="rotate(-90 276.173 179.999)"
        fill="black"
      />
      <ellipse
        cx="83.827"
        cy="179.999"
        rx="43.8255"
        ry="43.826"
        transform="rotate(-90 83.827 179.999)"
        fill="black"
      />
      <ellipse
        cx="179.997"
        cy="83.823"
        rx="43.8255"
        ry="43.826"
        transform="rotate(-90 179.997 83.823)"
        fill="black"
      />
      <ellipse
        cx="179.997"
        cy="276.175"
        rx="43.8255"
        ry="43.826"
        transform="rotate(-90 179.997 276.175)"
        fill="black"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_2269_789"
          x1="346.377"
          y1="25.4615"
          x2="0.00221924"
          y2="293.389"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#F4F4FF" />
          <Stop offset="1" stopColor="#6D6DF6" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export function FinancialSupporter2Card({width}: BadgeCardProps) {
  return (
    <Svg width={width} height={width} viewBox="0 0 360 360" fill="none">
      <Rect width="360" height="360" rx="32" fill="#DCDCFF" />
      <Rect
        x="3"
        y="3"
        width="354"
        height="354"
        rx="29"
        stroke="url(#paint0_linear_2269_823)"
        strokeOpacity="0.6"
        strokeWidth="6"
      />
      <Path
        d="M55.4014 184.986V175.019H304.589V184.986H55.4014Z"
        fill="black"
        stroke="black"
        strokeWidth="9.23678"
      />
      <ellipse
        cx="71.604"
        cy="179.994"
        rx="34.8865"
        ry="34.8862"
        transform="rotate(-90 71.604 179.994)"
        fill="black"
      />
      <ellipse
        cx="288.395"
        cy="179.994"
        rx="34.8865"
        ry="34.8862"
        transform="rotate(-90 288.395 179.994)"
        fill="black"
      />
      <Path
        d="M109.737 76.9548L118.19 71.6732L250.245 282.986L241.792 288.268L109.737 76.9548Z"
        fill="black"
        stroke="black"
        strokeWidth="9.23678"
      />
      <ellipse
        cx="34.8863"
        cy="34.8864"
        rx="34.8863"
        ry="34.8864"
        transform="matrix(0.84806 -0.529901 0.529938 0.848037 74.4912 76.9785)"
        fill="black"
      />
      <ellipse
        cx="34.8863"
        cy="34.8864"
        rx="34.8863"
        ry="34.8864"
        transform="matrix(0.848071 -0.529883 0.529956 0.848025 189.37 260.795)"
        fill="black"
      />
      <Path
        d="M241.808 71.701L250.261 76.9825L118.206 288.295L109.753 283.014L241.808 71.701Z"
        fill="black"
        stroke="black"
        strokeWidth="9.23678"
      />
      <ellipse
        cx="34.8863"
        cy="34.8864"
        rx="34.8863"
        ry="34.8864"
        transform="matrix(0.848061 0.529898 -0.52994 0.848035 226.337 40.0215)"
        fill="black"
      />
      <ellipse
        cx="34.8863"
        cy="34.8864"
        rx="34.8863"
        ry="34.8864"
        transform="matrix(0.848071 0.529883 -0.529956 0.848025 111.452 223.854)"
        fill="black"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_2269_823"
          x1="346.377"
          y1="25.4615"
          x2="0.00221924"
          y2="293.389"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#F4F4FF" />
          <Stop offset="1" stopColor="#6D6DF6" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export function FinancialSupporter3Card({width}: BadgeCardProps) {
  return (
    <Svg width={width} height={width} viewBox="0 0 360 360" fill="none">
      <Rect width="360" height="360" rx="32" fill="#DCDCFF" />
      <Rect
        x="3"
        y="3"
        width="354"
        height="354"
        rx="29"
        stroke="url(#paint0_linear_2269_881)"
        strokeOpacity="0.6"
        strokeWidth="6"
      />
      <Path
        d="M184.866 301.736L175.127 301.736L175.127 58.2617L184.866 58.2617L184.866 301.736Z"
        fill="black"
        stroke="black"
        strokeWidth="6.15785"
      />
      <ellipse
        cx="180.004"
        cy="66.7822"
        rx="26.7823"
        ry="26.7822"
        fill="black"
      />
      <ellipse
        cx="180.004"
        cy="293.22"
        rx="26.7823"
        ry="26.7822"
        fill="black"
      />
      <Path
        d="M58.2623 184.867L58.2623 175.128L301.737 175.128L301.737 184.867L58.2623 184.867Z"
        fill="black"
        stroke="black"
        strokeWidth="6.15785"
      />
      <ellipse
        cx="293.213"
        cy="180.009"
        rx="26.7822"
        ry="26.7823"
        transform="rotate(90 293.213 180.009)"
        fill="black"
      />
      <ellipse
        cx="66.7871"
        cy="180.009"
        rx="26.7822"
        ry="26.7823"
        transform="rotate(90 66.7871 180.009)"
        fill="black"
      />
      <Path
        d="M269.533 262.643L262.646 269.529L90.4836 97.367L97.3701 90.4805L269.533 262.643Z"
        fill="black"
        stroke="black"
        strokeWidth="6.15785"
      />
      <circle
        cx="26.7822"
        cy="26.7822"
        r="26.7822"
        transform="matrix(0.707108 -0.707106 0.707108 0.707106 62.0771 99.9492)"
        fill="black"
      />
      <circle
        cx="26.7822"
        cy="26.7822"
        r="26.7822"
        transform="matrix(0.707108 -0.707106 0.707108 0.707106 222.188 260.059)"
        fill="black"
      />
      <Path
        d="M97.3674 269.526L90.4809 262.639L262.644 90.4768L269.53 97.3633L97.3674 269.526Z"
        fill="black"
        stroke="black"
        strokeWidth="6.15785"
      />
      <circle
        cx="26.7822"
        cy="26.7822"
        r="26.7822"
        transform="matrix(0.707108 0.707106 -0.707108 0.707106 260.065 62.0664)"
        fill="black"
      />
      <circle
        cx="26.7822"
        cy="26.7822"
        r="26.7822"
        transform="matrix(0.707108 0.707106 -0.707108 0.707106 99.9463 222.18)"
        fill="black"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_2269_881"
          x1="346.377"
          y1="25.4615"
          x2="0.00221924"
          y2="293.389"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#F4F4FF" />
          <Stop offset="1" stopColor="#6D6DF6" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export function TechSupportCard({width}: BadgeCardProps) {
  return (
    <Svg width={width} height={width} viewBox="0 0 360 360" fill="none">
      <Rect width="360" height="360" rx="32" fill="#DCDCFF" />
      <Rect
        x="3"
        y="3"
        width="354"
        height="354"
        rx="29"
        stroke="url(#paint0_linear_2269_949)"
        strokeOpacity="0.6"
        strokeWidth="6"
      />
      <Mask
        id="mask0_2269_949"
        maskUnits="userSpaceOnUse"
        x="40"
        y="40"
        width="280"
        height="280">
        <Path d="M40 40H320V320H40V40Z" fill="#D9D9D9" />
      </Mask>
      <G mask="url(#mask0_2269_949)">
        <Path
          d="M402.446 -76.668C421.346 -76.668 436.668 -61.3462 436.668 -42.4457V137.999C436.668 156.899 421.346 172.221 402.446 172.221H222.002C203.101 172.221 187.779 156.899 187.779 137.999V-42.4457C187.779 -61.3462 203.101 -76.668 222.002 -76.668H402.446ZM228.224 -61.1124C214.478 -61.1124 203.335 -49.9693 203.335 -36.2235V131.776C203.335 145.522 214.478 156.665 228.224 156.665H396.224C409.969 156.665 421.113 145.522 421.113 131.776V-36.2235C421.113 -49.9693 409.969 -61.1124 396.224 -61.1124H228.224Z"
          fill="black"
        />
        <Path
          d="M390 -45.5586C398.591 -45.5586 405.555 -38.5941 405.555 -30.003V125.553C405.555 134.144 398.591 141.108 390 141.108H234.444C225.853 141.108 218.889 134.144 218.889 125.553V-30.003C218.889 -38.5941 225.853 -45.5586 234.444 -45.5586H390ZM243.778 -30.003C238.623 -30.003 234.444 -25.8244 234.444 -20.6697V116.219C234.444 121.374 238.623 125.553 243.778 125.553H380.666C385.821 125.553 390 121.374 390 116.219V-20.6697C390 -25.8244 385.821 -30.003 380.666 -30.003H243.778Z"
          fill="black"
        />
        <Path
          d="M402.446 187.777C421.346 187.777 436.668 203.099 436.668 222V402.444C436.668 421.344 421.346 436.666 402.446 436.666H222.002C203.101 436.666 187.779 421.344 187.779 402.444V222C187.779 203.099 203.101 187.777 222.002 187.777H402.446ZM228.224 203.333C214.478 203.333 203.335 214.476 203.335 228.222V396.222C203.335 409.968 214.478 421.111 228.224 421.111H396.224C409.969 421.111 421.113 409.968 421.113 396.222V228.222C421.113 214.476 409.969 203.333 396.224 203.333H228.224Z"
          fill="black"
        />
        <Path
          d="M390 218.891C398.591 218.891 405.555 225.855 405.555 234.446V390.002C405.555 398.593 398.591 405.557 390 405.557H234.444C225.853 405.557 218.889 398.593 218.889 390.002V234.446C218.889 225.855 225.853 218.891 234.444 218.891H390ZM243.778 234.446C238.623 234.446 234.444 238.625 234.444 243.78V380.668C234.444 385.823 238.623 390.002 243.778 390.002H380.666C385.821 390.002 390 385.823 390 380.668V243.78C390 238.625 385.821 234.446 380.666 234.446H243.778Z"
          fill="black"
        />
        <Path
          d="M138.001 -76.668C156.901 -76.668 172.223 -61.3462 172.223 -42.4457V137.999C172.223 156.899 156.901 172.221 138.001 172.221H-42.4438C-61.3442 172.221 -76.666 156.899 -76.666 137.999V-42.4457C-76.666 -61.3462 -61.3442 -76.668 -42.4438 -76.668H138.001ZM-36.2216 -61.1124C-49.9673 -61.1124 -61.1105 -49.9693 -61.1105 -36.2235V131.776C-61.1105 145.522 -49.9673 156.665 -36.2216 156.665H131.778C145.524 156.665 156.667 145.522 156.667 131.776V-36.2235C156.667 -49.9693 145.524 -61.1124 131.778 -61.1124H-36.2216Z"
          fill="black"
        />
        <Path
          d="M125.554 -45.5586C134.146 -45.5586 141.11 -38.5941 141.11 -30.003V125.553C141.11 134.144 134.146 141.108 125.554 141.108H-30.0011C-38.5922 141.108 -45.5566 134.144 -45.5566 125.553V-30.003C-45.5566 -38.5941 -38.5922 -45.5586 -30.0011 -45.5586H125.554ZM-20.6677 -30.003C-25.8224 -30.003 -30.0011 -25.8244 -30.0011 -20.6697V116.219C-30.0011 121.374 -25.8224 125.553 -20.6677 125.553H116.221C121.376 125.553 125.554 121.374 125.554 116.219V-20.6697C125.554 -25.8244 121.376 -30.003 116.221 -30.003H-20.6677Z"
          fill="black"
        />
        <Path
          d="M138.001 187.777C156.901 187.777 172.223 203.099 172.223 222V402.444C172.223 421.344 156.901 436.666 138.001 436.666H-42.4438C-61.3442 436.666 -76.666 421.344 -76.666 402.444V222C-76.666 203.099 -61.3442 187.777 -42.4438 187.777H138.001ZM-36.2216 203.333C-49.9673 203.333 -61.1105 214.476 -61.1105 228.222V396.222C-61.1105 409.968 -49.9673 421.111 -36.2216 421.111H131.778C145.524 421.111 156.667 409.968 156.667 396.222V228.222C156.667 214.476 145.524 203.333 131.778 203.333H-36.2216Z"
          fill="black"
        />
        <Path
          d="M125.554 218.891C134.146 218.891 141.11 225.855 141.11 234.446V390.002C141.11 398.593 134.146 405.557 125.554 405.557H-30.0011C-38.5922 405.557 -45.5566 398.593 -45.5566 390.002V234.446C-45.5566 225.855 -38.5922 218.891 -30.0011 218.891H125.554ZM-20.6677 234.446C-25.8224 234.446 -30.0011 238.625 -30.0011 243.78V380.668C-30.0011 385.823 -25.8224 390.002 -20.6677 390.002H116.221C121.376 390.002 125.554 385.823 125.554 380.668V243.78C125.554 238.625 121.376 234.446 116.221 234.446H-20.6677Z"
          fill="black"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_2269_949"
          x1="346.377"
          y1="25.4615"
          x2="0.00221924"
          y2="293.389"
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#F4F4FF" />
          <Stop offset="1" stopColor="#6D6DF6" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
